export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14908.4d9aa124.jpg";